import { useEffect, useRef } from 'react';

export const useModalFocus = (isVisible: boolean) => {
  const previousFocus = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (!isVisible) return;

    previousFocus.current = document.activeElement as HTMLElement | null;

    const timer = setTimeout(() => {
      const modal = document.querySelector('[data-testid="modal-backdrop"]:last-of-type') as HTMLElement | null;
      if (modal) {
        modal.setAttribute('tabIndex', '-1');
        modal.focus();
      }
    }, 0);

    return () => {
      if (previousFocus.current) {
        previousFocus.current.focus();
      }
      clearTimeout(timer);
    };
  }, [isVisible]);
};
